<template><div class="suggestions">
  <slot>
    <input
        type="text"
        :value="value"
        @input="$emit('input',$event.target.value)"
        :placeholder="placeholder"
        @focus="onFocus()"
        @blur="onBlur()"
        @keydown.up="up"
        @keydown.down="down"
        @keydown.enter="enter"
      />
  </slot>
  <div class="list" :class="{mouseover:mouseover}" v-if="show && items.length && !(items.length === 1 && items[0] === value)">
    <div
        v-for="(item,i) in items"
        :key="item"
        v-html="item"
        @mousedown="onClick(item)"
        :class="{highlight:highlight===i}"
        @mouseover="over(i)"
        @mousemove="over(i)"
      />
  </div>
</div></template>
<script>
export default {
  name: 'suggestions',
  props: ['items','value','placeholder'],
  emits: ['input'],
  data() {
    return {
      show: false,
      highlight: null,
      mouseover: false,
    }
  },
  methods: {
    onFocus() { this.show = true },
    onBlur() { this.show = false },
    onClick(item) { this.$emit('input', item) },
    up() {
      this.mouseover = false
      if (!this.highlight) this.highlight = this.items.length - 1
      else this.highlight--
    },
    down() {
      this.mouseover = false
      if (this.highlight === null || (this.highlight === this.items.length - 1)) this.highlight = 0
      else this.highlight++
    },
    enter() {
      if (this.highlight === null)
        return
      this.$emit('input', this.items[this.highlight])
    },
    over(i) {
      this.highlight = i
      this.mouseover = true
    },
  },
  watch: {
    show() {
      this.highlight = null
    },
  },
}
</script>
<style lang="scss" scoped>

.suggestions {
  position: relative;
  overflow: visible;
  input { width: 100%; }
  .list {
    position: absolute;
    top: 100%;
    margin-top: 1px;
    border: 1px solid #000;
    border-radius: 3px;
    background: #fff;
    z-index: 1;
    font-weight: normal;
    color: #000;
    display: flex;
    flex-direction: column;
    > div {
      padding: 2px 3px;
    }
    .highlight, &.mouseover > div:hover {
      background: #aaf;
    }
  }
}

</style>
